import {Location} from "@angular/common";
import {HttpHeaders } from "@angular/common/http";
import {Component, ViewChild} from "@angular/core";
import {NgForm } from "@angular/forms";
import {finalize, catchError, throwError } from "rxjs";
import {HttpService } from "src/app/services/http.service";
import {UtilService} from "../../services/util.service";
import {StateService} from "../../services/state.service";


@Component({
    selector: 'app-change-user-email',
    templateUrl: './change-username.component.html',
    styleUrl: './change-username.component.scss',
    standalone: false
})
export class ChangeUserNameComponent {
  @ViewChild('fUpdateUsrName', { read: NgForm }) fUpdateUsrName!: NgForm;
  isLoading = false;
  email: any;
  oldPassword: any;
  constructor(private location: Location, private httpService: HttpService, private util: UtilService, private stateService: StateService) { }

  onUpdateInfo(formData: any) {
    this.isLoading = true;
    let request = {
      oldPassword: window.btoa(this.oldPassword),
      email: formData.email,
      old_email: this.stateService.user.email,
    };
    const params = this.httpService.createHttpParams(request);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post('/update-username', params, options).pipe(
      finalize(() => { this.isLoading = false }),
      catchError(err => {
        this.util.displayDialogMessage("Error", "Failed to update user name");
        return throwError(err);
      })
    ).subscribe(response => {
      if(response){
        this.stateService.user.email=formData.email;
        this.fUpdateUsrName.form.reset();
        this.util.displayDialogMessage('Success', 'You have successfully updated your user name.');
      }
    });
  }

}
